import { render, staticRenderFns } from "./BankTransferForm.vue?vue&type=template&id=7c645792&scoped=true"
import script from "./BankTransferForm.vue?vue&type=script&lang=ts"
export * from "./BankTransferForm.vue?vue&type=script&lang=ts"
import style0 from "./BankTransferForm.vue?vue&type=style&index=0&id=7c645792&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c645792",
  null
  
)

export default component.exports